/*
 * Copyright (c) 2019. Willker Gomes
 */
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  form {
    span {
      font-size: 16px;
      color: #707070;
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    padding: 12px 30px;
    border-radius: 4px;
    border-color: #b1aeae;
    border-width: 1px;
    font-size: 16px;
    box-shadow: 0 1px 3px rgb(0, 0, 0, 0.16);
    background: #eaeaea;

    @media (max-width: 450px) {
      font-size: 12px;
      padding: 6px 15px;
    }
  }
`;

export const ImageContent = styled.div`
  display: flex;
  flex-direction: column;

  span {
    font-size: 12px;
  }
`;
